import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SharedPlan from './pages/SharedPlan';
import ExerciseDetail from './pages/ExerciseDetail';
import ProtectedRoute from './components/ProtectedRoute';
import Loading from './components/Loading';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simula il caricamento iniziale dell'applicazione
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // Mostra il loading per 2 secondi

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/shared-plan/:token" element={<SharedPlan />} />
        <Route 
          path="/dashboard"  
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/dashboard/exercises/:id"
          element={
            <ProtectedRoute>
              <ExerciseDetail />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
